import { render, staticRenderFns } from "./StudentRefusedNewLessonTimeNotification.vue?vue&type=template&id=266cafe5&"
import script from "./StudentRefusedNewLessonTimeNotification.vue?vue&type=script&lang=js&"
export * from "./StudentRefusedNewLessonTimeNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports